export default {
  baseStyle: {
    fontFamily: 'Open Sans',
    _focus: {
      outline: 'none',
      boxShadow: 'none'
    }
  }
}
